import React from "react";
import formatCurrency from "./formatCurrency";

export default function fee(value) {
  return <span>{formatCurrency(value)}</span>;
}
